/**
 * LeadValidator
 * 
 * Responsabilidade: Validação de dados de leads antes de persistência
 * Princípio: Single Responsibility - apenas validação
 */

import { InfrastructureError } from '../../../core/errors/DomainErrors';

export class LeadValidator {
    /**
     * Valida campos obrigatórios de uma oportunidade
     * Previne violações de constraints do banco de dados
     */
    static validateRequiredFields(dbLead: any): void {
        if (!dbLead.title || dbLead.title.trim().length === 0) {
            throw new InfrastructureError('Título da negociação é obrigatório e não pode estar vazio');
        }

        // Stage é obrigatório APENAS para negociações abertas
        // Negociações ganhas/perdidas não têm stage (foram removidas do funil)
        const status = dbLead.status || 'open';
        if (status === 'open' && (!dbLead.stage || dbLead.stage.trim().length === 0)) {
            throw new InfrastructureError('Etapa da negociação é obrigatória para negociações abertas');
        }

        // Validação robusta para origin
        // O campo origin é obrigatório e deve ser uma origem válida do banco
        if (!dbLead.origin || typeof dbLead.origin !== 'string' || dbLead.origin.trim().length === 0) {
            console.error('[LeadValidator] Origin inválido:', dbLead.origin);
            throw new InfrastructureError('Origem da negociação é obrigatória');
        }

        // Sanitização: remove espaços extras
        dbLead.origin = dbLead.origin.trim();
    }

    /**
     * Valida ID de entrada
     */
    static validateId(id: string, fieldName = 'ID'): void {
        if (!id || id.trim().length === 0) {
            throw new InfrastructureError(`${fieldName} é obrigatório`);
        }
    }

    /**
     * Valida organization ID para operações multi-tenant
     */
    static validateOrganizationId(organizationId?: string): void {
        if (!organizationId) {
            throw new InfrastructureError('Organization ID é obrigatório para criar nova oportunidade');
        }
    }

    /**
     * Verifica se o ID é temporário (criado no frontend)
     */
    static isTemporaryId(id: string): boolean {
        return id.startsWith('temp_');
    }
}
